import {createRef} from "../createRef";

export default createRef({
    "id": "DOC_STATE_REF",
    "source": "DOC_STATE_REF",
    "fields": [
    {   "column": "doc_type", },
    {   "column": "state", },
    {   "column": "name", },
    ],
}, {
    buildFilters: (docType) => [
    {column: 'doc_type', operator: '=', value: docType, dataType: 'text'}
    ]
});
